import { createSelector } from '@ngrx/store';
import { selectDashboardState } from '../dashboard.selectors';

export const selectFollowersState = createSelector(
  selectDashboardState,
  (dashboardState) => dashboardState.followers
);

export const selectFollowers = (props: { userId: number|string }) => {
  return createSelector(
    selectFollowersState,
    (followersState) => {
      // If user id is not not current one
      if (props.userId !== followersState.userId ) {
        return [];
      }
      return followersState.followers.users;
    }
  );
};


export const selectFollowings = (props: { userId: number|string }) => {
  return createSelector(
    selectFollowersState,
    (followersState) => {
      // If user id is not not current one
      if (props.userId !== followersState.userId ) {
        return [];
      }
      return followersState.followings.users;
    }
  );
};

export const selectFollowersLoading = (props: { userId: number|string }) => {
  return createSelector(
    selectFollowersState,
    (followersState) => {
      // If user id is not not current one
      if (props.userId !== followersState.userId ) {
        return false;
      }
      return followersState.followers.loading;
    }
  );
};

export const selectFollowingsLoading = (props: { userId: number|string }) => {
  return createSelector(
    selectFollowersState,
    (followersState) => {
      // If user id is not not current one
      if (props.userId !== followersState.userId ) {
        return false;
      }
      return followersState.followings.loading;
    }
  );
};


export const selectFollowersLoaded = (props: { userId: number|string }) => {
  return createSelector(
    selectFollowersState,
    (followersState) => {
      // If user id is not not current one
      if (props.userId !== followersState.userId ) {
        return false;
      }
      return followersState.followers.loaded;
    }
  );
};

export const selectFollowingsLoaded = (props: { userId: number|string }) => {
  return createSelector(
    selectFollowersState,
    (followersState) => {
      // If user id is not not current one
      if (props.userId !== followersState.userId ) {
        return false;
      }
      return followersState.followings.loaded;
    }
  );
};
